import React, { useEffect, useState } from 'react'
import {NumericFormat} from 'react-number-format';

const NumberField = ({
    inputLabel, 
    fieldId, 
    hasError, 
    returnFieldValue, 
    preloadValue, 
    inputPlaceholder,
    maxLength,
    requiredField,
    disabled = false
}) => {
    const [ fieldValue, setFieldValue ] = useState(0)

    useEffect(() => {
        setFieldValue(preloadValue);
    }, [preloadValue]);

    const setValue = (value, source) => {
        setFieldValue(value)

        if (source === 'event') {
            returnFieldValue(value)
        }
    }

    return (
        <div>
            {inputLabel && inputLabel !== '' && <label 
                className={`text-sm lg:text-md cursor-text z-10 relative py-1 transition mb-2 block duration-200  
                ${hasError ? 'text-red-600' : 'text-gray-500'}`}
            >
                {requiredField && requiredField === true && <span className='text-red-600'>*</span>} {inputLabel}
            </label>}

            <NumericFormat
                id={fieldId}
                thousandsGroupStyle="thousand"
                value={fieldValue}
                prefix=""
                decimalSeparator="."
                displayType="input"
                type="text"
                maxLength={maxLength}
                thousandSeparator={true}
                allowNegative={false}
                decimalScale={2}
                placeholder={inputPlaceholder}
                disabled={disabled}
                fixedDecimalScale={false}
                className={`rounded py-3 px-3 text-sm block w-full focus:border-gray-800 focus:outline-none hover:border-gray-200 hover:bg-gray-50 border bg-gray-100  transition duration-200 focus:bg-white font-outfit placeholder:font-outfit  ${hasError ? 'border-red-600' : 'border-gray-100'}`}
                onValueChange={(values, sourceInfo)=>{setValue(values.floatValue, sourceInfo.source)}}
            />
        </div>
    )

}

export default NumberField